// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { numericalValuesOnly } from 'helpers/regex'

// NOTE - this expects s to be a string

const stringIsNumber = s => (
  s.match(numericalValuesOnly) !== null &&
  !isNaN(+s)
)

export default stringIsNumber
